module.exports = __webpack_public_path__ + "static/thank-you@2x-7f00e76858657e563014497653b92a58.png";